import styled from "styled-components"

interface TextOptionType {
  fontSize?: number
  color?: string
  fontWeight?: "normal" | "bold" | "lighter"
  $align?: "start" | "center" | "end"
}

const TextSpan = styled.span<TextOptionType>`
  margin: 0px;
  padding: 0px;
  font-size: ${(props) => `${props.fontSize || 10}px`};
  line-height: 1.5;
  font-weight: ${(props) => `${props.fontWeight || "normal"}`};
  color: ${(props) => `${props.color || "black"}`};
  white-space: pre-line;
`

const TextDiv = styled.div<TextOptionType>`
  box-sizing: border-box;
  width: 100%;
  margin: 0px;
  padding: 0px;
  font-size: ${(props) => `${props.fontSize || 10}px`};
  line-height: 1.5;
  font-weight: ${(props) => `${props.fontWeight || "normal"}`};
  color: ${(props) => `${props.color || "black"}`};
  white-space: pre-line;
  text-align: ${(props) => `${props.$align || "center"}`};
`

const UnderlinedTextButton = styled.span<TextOptionType>`
  margin: 0px;
  padding: 0px;
  font-size: ${(props) => `${props.fontSize || 10}px`};
  line-height: 1.5;
  font-weight: normal;
  color: ${(props) => `${props.color || "black"}`};
  white-space: pre-line;
  text-decoration: underline;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    font-weight: bold;
  }
`

const TextButton = styled(TextSpan).attrs(() => ({
  fontWeight: "bold",
}))`
  cursor: pointer;
  transition: all 0.3s ease;
`

interface TextInputProps {
  $isError: boolean
}

const TextInput = styled.input<TextInputProps>`
  box-sizing: border-box;
  width: 100%;
  border-radius: 20px;
  height: 45px;
  padding: 5px 25px;
  line-height: 36px;
  font-size: 16px;
  border: 2px solid
    ${(props) =>
      props.$isError ? "var(--custom-light-red)" : "var(--custom-platinum)"};
  outline-color: ${(props) =>
    props.$isError ? "var(--custom-light-red)" : "var(--custom-light-blue)"};
`

export { TextSpan, TextDiv, UnderlinedTextButton, TextButton, TextInput }
